import { useCallback, useState } from 'react';

import type { CrisisPlanNotNeededConfirmParams } from './types';

export default function useCrisisPlanNotNeededConfirm({
  hasSavedCrisisPlans,
  clearAll,
  setNoCrisisPlanNeeded,
}: CrisisPlanNotNeededConfirmParams) {
  const [isConfirmOpen, setIsConfirmOpen] = useState(false);

  const handleToggle = useCallback(
    (isNotNeeded: boolean) => {
      // Only marking the plan unnecessary is destructive, and only once rows exist.
      if (!isNotNeeded || !hasSavedCrisisPlans) {
        void setNoCrisisPlanNeeded(isNotNeeded);
        return;
      }
      setIsConfirmOpen(true);
    },
    [hasSavedCrisisPlans, setNoCrisisPlanNeeded],
  );

  const handleConfirm = useCallback(async () => {
    // Hold the dialog open until the bulk delete settles; abort on failure so the flag can't clear.
    if (!(await clearAll())) return;
    if (await setNoCrisisPlanNeeded(true)) setIsConfirmOpen(false);
  }, [clearAll, setNoCrisisPlanNeeded]);

  const closeConfirm = useCallback(() => setIsConfirmOpen(false), []);

  return { isConfirmOpen, handleToggle, handleConfirm, closeConfirm };
}
